import type { ReactNode } from "react";

import type { BoosterMultiplierOption } from "@api/products/boosterMultipliers";

import { PLACEHOLDER_TOKENS, TERMS_DELIMITER } from "./BalanceBoosterMultiplier.constants";

/**
 * Replace placeholder tokens in content strings
 */
export const replacePlaceholder = (text: string, token: string, value: string): string => {
  return text.replace(token, value);
};

/**
 * Format Avios amount with locale-specific formatting
 */
export const formatAviosAmount = (amount: number, locale: string): string => {
  return amount.toLocaleString(locale);
};

/**
 * Get the first card's Avios amount for content display
 */
export const getFirstCardAvios = (multiplierOptions: Array<BoosterMultiplierOption>): number => {
  return multiplierOptions.length > 0 ? multiplierOptions[0].aviosAmount : 0;
};

/**
 * Parse terms content from pipe-delimited string to React nodes
 */
export const parseTermsContent = (termsText: string): Array<ReactNode> => {
  return termsText.split(TERMS_DELIMITER).map((line, index, array) => (
    <div key={`term-${line.slice(0, 20)}-${index}`} style={{ marginBottom: index < array.length - 1 ? "8px" : "0" }}>
      {line.trim()}
    </div>
  ));
};

/**
 * Build display text with dynamic content replacement
 */
export const buildDisplayText = (contentText: string | undefined, aviosAmount: number, locale: string): string => {
  if (!contentText) {
    return "";
  }

  return replacePlaceholder(contentText, PLACEHOLDER_TOKENS.MAX_AVIOS, formatAviosAmount(aviosAmount, locale));
};
